import { AbstractAuditDto, AuditSearchDto } from '../../../service/dto';
import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-audit-timeline-search',
	standalone: false,
	templateUrl: './audit-timeline-search.component.html',
	styleUrl: './audit-timeline-search.component.scss'
})
export class AuditTimelineSearchComponent {
	list!: AuditSearchDto[];

	@Input()
	set audits(input: AbstractAuditDto[]){
		this.list = input.map(item => item as AuditSearchDto);
	}
}
